<template>
<div>
  <div class="login pb-8 sm:pb-0">
    <div class="flex flex-wrap justify-end lg:pr-20 sm:py-10">
      <div class="formR w-full md:w-1/2 lg:w-1/3 flex sm:block justify-center">
        <div class="w-full sm:max-w-xs xl:max-w-sm">
          <div class="mb-6 md:hidden">
            <img src="@/assets/image/ai/login_head.png" alt="" class="mx-auto object-contain w-full">
          </div>
          <div class="mb-6 mx-auto w-full"><img src="@/assets/image/ai/login_robot.png" alt="" class="mx-auto"></div>
          <p class="login-blue3-text text-center border-b login-blue-border text-sm font-semibold mb-5">請使用 LiveABC 官網會員帳號進行登入</p>
          <form class="w-full px-4">
            <div class="space-y-3">
              <div class="space-y-1 mb-6">
                <div class="space-y-2 mb-4">
                  <label class="login-blue3-text font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" for="email">帳號</label>
                  <input v-model="email" autocomplete="on" class="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" id="email" placeholder="請輸入電子信箱" name="email" type="text"/>
                </div>
                <div class="space-y-2 mb-4">
                  <label class="login-blue3-text font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" for="password">密碼</label>
                  <input v-model="password" autocomplete="on" class="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" id="password" name="password" type="password" placeholder="請輸入密碼" />
                </div>
              </div>
              <div class="flex justify-end">
                <a href="https://store.liveabc.com/forgotPwd" target="_blank" class="text-sm login-blue3-text font-semibold">忘記密碼？</a>
              </div>
              <a @click="loginFunc()" class="cursor-pointer ring-offset-background focus-visible:ring-ring flex h-10 w-full items-center justify-center whitespace-nowrap rounded-md login-blue2-bg px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-black/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">登入</a>
              <googleLogin />
              <div class="">
                <p class="text-sm sm:text-xs xl:text-sm login-blue2-text font-semibold whitespace-no-wrap text-center leading-relaxed">還不是會員嗎？<a href="https://store.liveabc.com/register" target="_blank" class="login-blue4-text font-semibold">立刻註冊新帳號</a>，<span class="sm:hidden"><br/></span>完成註冊後須回此網站登入</p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <footer>
    <div class="md:flex flex-wrap justify-center items-center text-white mx-auto p-6">
      <div class="pb-5 md:p-5 md:px-8">
        <p>地址：台北市八德路 3 段 32 號 12 樓</p>
        <p>客服電話：02-2578-7838</p>
      </div>
      <div class="pb-5 md:p-5 md:px-8">
        <p>客服信箱：service@liveabc.com</p>
        <p>客戶服務時間：週一至週五 09:00~17:30</p>
      </div>
      <div class="w-full lg:w-auto border-t xl:border-t-0 xl:border-l py-5 md:px-16 lg:p-5 lg:px-8">
        <p class="text-center">Copyright © 2024Hebron Soft Limited All Rights Reserved.</p>
      </div>
    </div>
  </footer>
</div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import googleLogin from '@/components/googleLogin.vue'
  export default {
    name: 'Login',
    metaInfo: {
      title: 'Login'
    },
    components: {
      googleLogin
    },
    data () {
      return {
        // email: 'yulunyangfrontend@gmail.com',
        // password: 'crystal1018'
        email: '',
        password: ''
      }
    },
    computed: {
      ...mapGetters([
        'authorized'
      ]),
    },
    mounted () {
      if (this.authorized) {
        this.$router.push({ name: 'Index' })
      }
    },
    methods: {
      ...mapActions({
        dologinWebsite: 'loginWebsite'
      }),
      async loginFunc () {
        let self = this
        if (self.email && self.password) {
          await self.dologinWebsite({ email: self.email, password: self.password})
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
.login {
  min-height: 100vh;
  background: #EAEDF2;
  background-image: url('~@/assets/image/bg_login_LL.png'), url('~@/assets/image/login_R.png');
  background-repeat: no-repeat;
  background-position: top left, bottom right;
  background-size: 60%, 30%;
  @media (max-width: 1024px) {
    background-image: url('~@/assets/image/bg_login_ML.png'), url('~@/assets/image/login_R.png');
    background-size: 55%, 30%;
  }
  @media (max-width: 640px) {
    background-image: none;
    background-size: 55%, 30%;
  }
}
// .formL {
//   min-height: 100vh;
//   background-image: url('~@/assets/image/ai/bg_login_L.png');
//   background-repeat: no-repeat;
//   background-position: top left;
//   background-size: contain;
//   @media (min-width: 1024px) {
//     background-image: url('~@/assets/image/ai/login_L.png');
//   }
// }
// .formR {
//   min-height: 100vh;
//   @media (min-width: 768px) {
//     background-image: url('~@/assets/image/ai/login_R.png');
//     background-repeat: no-repeat;
//     background-position: bottom right;
//     background-size: contain;
//   }
// }
.login-white-bg {
  background-color: #EAEDF2;
}
.login-blue1-bg {
  background-color: #08217E;
}
.login-blue2-bg {
  background-color: #0E103E;
}
.login-blue3-bg {
  background-color: #5A5D9B;
}
.login-white-text {
 color: #EAEDF2;
}
.login-blue1-text {
 color: #08217E;
}
.login-blue2-text {
 color: #0E103E;
}
.login-blue3-text {
 color: #5A5D9B;
}
.login-blue4-text{
  color: #F546D9;
}

.login-blue-border {
 border-color: #5A5D9B;
}
footer {
  background: linear-gradient(113.68deg, #102A8A 6.89%, #0E618F 98%);

}
</style>
